<template>
  <div class="modal fade StudioContact show">
    <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
      <div class="modal-content">
        <div class="modal-body px-4 py-4 py-md-5 px-lg-5">
          <nav id="navbar" class="navbar activenavbar-expand-md navbar-light bg-light d-md-none">
            <div class="container-fluid d-flex justify-content-between h-100">
              <div>
                <a class="navbar-brand">
                  <span class="f-10 d-none d-md-block">東京にあるレンタルスタジオ･ハウススタジオならUBIQS LOCATION</span>
                  <img :src="`${imgPath}/images/headerLogo.svg`" />
                </a>
              </div>
              <div class="d-md-none">
                <div class="d-flex justify-content-end">
                  <a class="nav-link search3">
                    <img :src="`${imgPath}/images/searchButton.svg`" />
                  </a>
                  <a class="nav-link d-inline drawerButton">
                    <img :src="`${imgPath}/images/headerMenu.svg`" />
                  </a>
                </div>
              </div>
            </div>
          </nav>
          <button @click="$emit('close')" type="button" class="close modal-close d-none d-md-block trigger">
            <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M9.37537 10.2358C8.94837 9.85578 8.94837 9.2398 9.37537 8.8598C9.75537 8.4798 10.3723 8.4798 10.7513 8.8598L18.3444 16.4518L25.9364 8.8598C26.3154 8.4798 26.9334 8.4798 27.3124 8.8598C27.6924 9.2398 27.6924 9.85578 27.3124 10.2358L19.7203 17.8758L27.3124 25.4688C27.6924 25.8488 27.6924 26.4648 27.3124 26.8448C26.9334 27.2248 26.3154 27.2248 25.9364 26.8448L18.3444 19.2518L10.7513 26.8448C10.3723 27.2248 9.75537 27.2248 9.37537 26.8448C8.94837 26.4648 8.94837 25.8488 9.37537 25.4688L16.9684 17.8758L9.37537 10.2358ZM18.3434 0.174805C23.2314 0.174805 27.6444 2.16778 30.8224 5.34778C34.0024 8.57478 35.9954 12.9878 35.9954 17.8748C35.9954 22.7158 34.0024 27.1288 30.8224 30.3548C27.6434 33.5338 23.2304 35.5268 18.3434 35.5268C13.4564 35.5268 9.0424 33.5338 5.8634 30.3548C2.6364 27.1278 0.691406 22.7148 0.691406 17.8748C0.691406 12.9868 2.6364 8.57378 5.8634 5.34778C9.0434 2.16778 13.4564 0.174805 18.3434 0.174805ZM29.4474 6.77179C26.6004 3.92379 22.6624 2.16779 18.3434 2.16779C13.9774 2.16779 10.0864 3.92379 7.23938 6.77179C4.39138 9.57179 2.63538 13.5098 2.63538 17.8758C2.63538 22.1938 4.39138 26.1328 7.23938 28.9798C10.0864 31.7798 13.9774 33.5348 18.3434 33.5348C22.6614 33.5348 26.6004 31.7798 29.4474 28.9798C32.2944 26.1318 34.0504 22.1938 34.0504 17.8758C34.0504 13.5098 32.2944 9.57179 29.4474 6.77179Z"
                fill="#003B71"
              />
            </svg>
          </button>
          <div class="beforeAjax" v-if="inputForm">
            <h5>お問い合わせ</h5>
            <form @submit.prevent="submit" id="form">
              <div class="row">
                <div class="col-lg-6 pr-xl-3">
                  <div class="form-group row">
                    <label for="studioName" class="col-lg-4 col-form-label">スタジオ名</label>
                    <div class="col-lg-8">
                      <h6>{{ studioName }}</h6>
                      <input type="hidden" readonly class="form-control-plaintext" id="studioName" :value="studioName" />
                      <input type="hidden" readonly class="form-control-plaintext" id="studioId" :value="studioId" />
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="name" class="col-lg-4 col-form-label">お名前<span>*</span></label>
                    <div class="col-lg-8">
                      <input type="text" class="form-control-plaintext StudioContactName" id="name" v-model="name" @blur="validation()" />
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="phone" class="col-lg-4 col-form-label">電話番号<span>*</span></label>
                    <div class="col-lg-8">
                      <input type="tel" class="form-control-plaintext StudioContactphone" id="phone" v-model="phone" @blur="validation()" />
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="email" class="col-lg-4 col-form-label">メールアドレス<span>*</span></label>
                    <div class="col-lg-8">
                      <input type="email" class="form-control-plaintext" id="email" v-model="email" @blur="validation()" />
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 pl-xl-3 d-flex flex-column justify-content-end">
                  <div class="form-group row">
                    <label for="shootingDate" class="col-5 col-md-4 col-form-label">撮影希望日</label>
                    <div class="input-group col-7 col-md-8">
                      <datepicker
                        class="form-control-plaintext p-0"
                        :disabled-dates="disabledDates"
                        v-model="shootingDate"
                        :format="DatePickerFormat"
                        :language="ja"
                        @blur="validation()"
                        :placeholder="icon"
                      />
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="locationScouting" class="col-5 col-md-4 col-form-label">ロケハン希望日</label>
                    <div class="input-group col-7 col-md-8">
                      <datepicker
                        class="form-control-plaintext p-0"
                        :disabled-dates="disabledDates"
                        v-model="locationScouting"
                        :format="DatePickerFormat"
                        :language="ja"
                        @blur="validation()"
                        :placeholder="icon"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label for="purposeOfUse" class="col-form-label">利用用途</label>
                <textarea class="form-control" id="purposeOfUse" rows="3" v-model="purposeOfUse" @blur="validation()"></textarea>
              </div>
              <div class="form-group">
                <label for="detail" class="col-form-label">詳細内容</label>
                <textarea class="form-control" id="detail" rows="3" v-model="detail" @blur="validation()"></textarea>
              </div>
              <div class="text-center">
                <input type="checkbox" id="terms" name="checkbox01" v-model="terms" @change="changeTerms" />
                <label for="terms" class="checkbox01 mb-3"><a href="/terms" target="_blank">利用規約</a>に同意する</label>
              </div>
              <div class="text-center" v-show="!items.name">
                <p class="mb-2 text-danger">名前を入力してください</p>
              </div>
              <div class="text-center" v-show="!items.phone">
                <p class="mb-2 text-danger">有効な電話番号を入力してください</p>
              </div>
              <div class="text-center" v-show="!items.email">
                <p class="mb-2 text-danger">有効なメールアドレスを入力してください</p>
              </div>
              <div class="text-center submitBtnArea">
                <button id="submitBtn" type="submit" :disabled="!isValidation">問い合わせる</button>
              </div>
              <div class="ModalFooterBtns d-md-none">
                <div class="container h-100">
                  <div class="d-flex justify-content-center align-items-center h-100">
                    <button class="close modalClose modal-close" @click="$emit('close')">問い合わせるを閉じる</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="ajaxSuccess" v-if="axiosSuccess">
            <h5>問い合わせを受け付けました</h5>
            <div class="text-left">
              <p>入力いただいたメールアドレス宛てに、自動返信メールをお送りさせていただきました。</p>
              <br />
              <p>
                もし、メールが30分以内に届かない場合は、お問い合わせが完了していない可能性がございますので、
                お手数をおかけしますが、再度、お問い合わせフォームにご記入いただければ幸いです。
              </p>
            </div>
            <div class="ModalFooterBtns d-md-none">
              <div class="container h-100">
                <div class="d-flex justify-content-center align-items-start h-100">
                  <div>
                    <button class="close modalClose modal-close" @click="$emit('close')">問い合わせるを閉じる</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="ajaxError" v-if="axiosError">
            <h5>システムエラー</h5>
            <div class="text-left">
              <p>お手数をおかけしますが、再度、お問い合わせフォームにご記入いただければ幸いです。</p>
            </div>
            <div class="ModalFooterBtns d-md-none">
              <div class="container h-100">
                <div class="d-flex justify-content-center align-items-start h-100">
                  <div>
                    <button class="close modalClose modal-close" @click="$emit('close')">問い合わせるを閉じる</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
import Datepicker from "vuejs-datepicker";
import { ja } from "vuejs-datepicker/dist/locale";
export default {
  name: "ContactForm",
  components: { Datepicker },
  props: {
    studioId: {
      type: String,
      require: true,
    },
    studioName: {
      type: String,
      require: true,
    },
    nonce: {
      type: String,
      require: true,
    },
    imgPath: {
      type: String,
      require: true,
    },
    postUrl: {
      type: String,
      require: true,
    },
  },
  data() {
    return {
      inputForm: true,
      axiosSuccess: false,
      axiosError: false,
      name: null,
      email: null,
      phone: null,
      shootingDate: null,
      locationScouting: null,
      purposeOfUse: null,
      detail: null,
      terms: 0,
      isValidation: false,
      scrollTop: 0,
      scrollpos: 0,
      items: {
        name: true,
        phone: true,
        email: true,
        terms: true,
      },
      ja: ja,
      DatePickerFormat: "yyyy/MM/dd",
      disabledDates: {
        to: new Date(),
      },
      icon: "\uf073",
    };
  },
  computed: {},
  mounted() {
    console.log(this.postUrl);
  },
  methods: {
    submit() {
      this.isValidation = !this.isValidation;
      let formData = new FormData();
      formData.append("action", "my_ajax");
      formData.append("nonce", this.nonce);
      formData.set("studioName", this.studioName);
      formData.set("studioId", this.studioId);
      formData.set("name", this.name);
      formData.set("phone", this.phone);
      formData.set("email", this.email ? this.email : "");
      formData.set("shootingDate", this.shootingDate ? this.format(this.shootingDate) : "");
      formData.set("locationScouting", this.locationScouting ? this.format(this.locationScouting) : "");
      formData.set("purposeOfUse", this.purposeOfUse ? this.purposeOfUse : "");
      formData.set("detail", this.detail ? this.detail : "");
      axios
        .post(this.postUrl, formData)
        .then((res) => {
          // console.log(res.data.result);
          if (res.data.result) {
            this.inputForm = false;
            this.axiosSuccess = true;
          } else {
            this.inputForm = false;
            this.axiosError = true;
          }
        })
        .catch((err) => {
          console.log(err);
          this.inputForm = false;
          this.axiosError = true;
        })
        .finally(() => {
          this.isValidation = !this.isValidation;
        });
    },
    validation() {
      // eslint-disable-next-line no-unused-vars, no-useless-escape
      const validRegexPhone = /^[0-9\-]{10,13}$/;
      // eslint-disable-next-line no-unused-vars
      const validRegexEmail =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      // Name
      if (!this.name) {
        this.items.name = false;
      } else {
        this.items.name = true;
      }
      // Phone
      if (!this.phone) {
        this.items.phone = false;
      } else {
        if (!this.phone.match(validRegexPhone)) {
          this.items.phone = false;
        } else {
          this.items.phone = true;
        }
      }
      // Email
      if (!this.email) {
        this.items.email = false;
      } else {
        if (!this.email.match(validRegexEmail)) {
          this.items.email = false;
        } else {
          this.items.email = true;
        }
      }
      if (this.terms != 0) {
        this.items.terms = true;
      } else {
        this.items.terms = false;
      }
      if (!this.items.name || !this.items.phone || !this.items.email || !this.items.terms) {
        this.isValidation = false;
      } else {
        this.isValidation = true;
      }
    },
    changeTerms() {
      this.terms = !this.terms == 0 ? 1 : 0;
      this.validation();
    },
    format(value) {
      return new Date(value).toLocaleDateString();
    },
  },
};
</script>
<style scoped>
p {
  white-space: break-spaces;
  font-size: 16px;
  color: rgb(45, 46, 49);
}

form {
  color: rgb(45, 46, 49);
  text-align: left;
}

.vdp-datepicker::v-deep input[type="text"] {
  height: 36px !important;
  text-align: right;
  width: 100%;
  font-family: FontAwesome;
  padding: 0.1rem 0.5rem;
}

/* Studio Contact */
.modal-trigger {
  cursor: pointer;
}

.StudioContact {
  cursor: auto;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  width: 100%;
  height: 100%;
  outline: 0;
  overflow: hidden;
  color: #2d2e31;
  display: block;
}

.StudioContact input[type="text"],
.StudioContact input[type="tel"],
.StudioContact input[type="email"] {
  height: 36px !important;
  padding: 0.1rem 0.5rem;
}

.StudioContact button[type="submit"] {
  background: linear-gradient(90deg, #003b71 0%, #0057a3 100%);
  border-radius: 3px;
  color: #fff;
  font-size: 18px;
  line-height: 32px;
  min-width: 200px;
  font-size: 13px;
  padding: 0;
}

.StudioContact button[type="submit"][disabled] {
  opacity: 0.5 !important;
}

.StudioContact label span {
  color: #f00;
  margin-left: 0.5rem;
}

.StudioContact .modal-content {
  background: #fefefe;
  box-shadow: none;
  border-radius: 0;
}

.StudioContact .modal-body {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.StudioContact .modal-body::-webkit-scrollbar {
  display: none;
}

.StudioContact .modal-dialog {
  display: block;
  align-items: center;
  max-width: 100vw;
  margin: 57px 0 0 0;
  min-height: calc(100% - 58px);
  max-height: calc(100% - 58px);
  position: fixed;
}

.StudioContact .modalClose {
  bottom: 90px;
  color: #0057a3;
}

.StudioContact .ModalFooterBtns {
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
  background: #fefefe;
  border-top: 1px solid #0057a3;
  height: 75px;
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.StudioContact form {
  margin-bottom: 240px;
}

.StudioContact .submitBtnArea {
  position: fixed;
  z-index: 10;
  width: 100%;
  bottom: 20px;
  left: 0;
}

.StudioContact .ajaxSuccess .ModalFooterBtns {
  border-top: none;
}

.StudioContact h5 {
  color: #003b71;
  text-align: center;
  margin-bottom: 1.5rem;
}

.StudioContact h6 {
  font-weight: 700;
  font-size: 20px;
  line-height: 38px;
  margin-bottom: 0;
}

.StudioContact .trigger {
  color: #003b71;
  position: absolute;
  right: 28px;
  top: 28px;
  will-change: transition;
  transition: all 0.3s 0s ease;
  -webkit-transition: all 0.3s 0s ease;
}

.StudioContact .trigger:hover {
  color: #003b71;
  opacity: 0.3 !important;
}

.StudioContact .form-control {
  font-size: 16px !important;
}

.StudioContact .checkbox01 a {
  color: #003b71;
  text-decoration: underline;
}

.StudioContact .checkbox01 a:hover {
  text-decoration: underline !important;
}

@media (min-width: 576px) {
}

@media (min-width: 768px) {
  .StudioContact .modal-dialog {
    margin: 1.75rem auto;
    display: flex;
    position: initial;
    max-width: 500px;
  }

  .StudioContact .modal-content {
    background: #fefefe;
    box-shadow: 0 0 8px gray;
    border-radius: 45.5px;
    min-height: auto;
  }

  .StudioContact form {
    margin-bottom: 0;
  }

  .StudioContact .submitBtnArea {
    position: initial;
  }
}

@media (min-width: 992px) {
  .StudioContact .modal-lg,
  .StudioContact .modal-xl {
    max-width: 950px;
  }
}

@media (min-width: 1200x) {
  .StudioContact .modal-xl {
    max-width: 1140px;
  }
}

#navbar {
  position: fixed;
  top: -57px;
  left: 0;
}
</style>
